/* Fresca — Reviews: on touch screens the marquee rows become native, swipeable scrollers that keep drifting.
   Progressive enhancement: without this file (and on mouse/trackpad devices) the CSS marquee runs, with
   hover-pause and the pause toggle. Reduced-motion users get the static, snap-scrolling rows from the CSS. */
(() => {
  'use strict';
  const touchMq = window.matchMedia('(hover: none) and (pointer: coarse)');
  const reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  const IDLE = 1800; // ms after a swipe before the row starts drifting again

  const init = (sec) => {
    if (sec._frDrift || !touchMq.matches || reducedMq.matches) return;
    const toggle = sec.querySelector('.fr-reviews__pause-input');
    const rows = Array.from(sec.querySelectorAll('.fr-reviews__row')).map((el) => {
      const rev = el.classList.contains('fr-reviews__row--rev');
      return { el, track: el.querySelector('.fr-reviews__track'), dir: rev ? -1 : 1, speed: rev ? 20 : 24, pos: 0, w: 0, set: -1, user: -1e9, held: false };
    }).filter((r) => r.track && r.track.firstElementChild);
    if (!rows.length) return;
    sec._frDrift = true;
    sec.classList.add('is-drift');

    const apply = (r) => {
      // keep the scroll offset inside the middle copy, so the loop is seamless and swipes work both ways
      if (r.pos < r.w * 0.5) r.pos += r.w;
      else if (r.pos >= r.w * 1.5) r.pos -= r.w;
      r.el.scrollLeft = r.pos;
      r.set = r.el.scrollLeft;
    };

    const gutter = () => { const c = sec.querySelector('.fr-container'); return c ? parseFloat(getComputedStyle(c).paddingLeft) || 0 : 0; };

    const measure = (r) => {
      const groups = r.track.children;
      const w = groups[0].getBoundingClientRect().width;
      if (!w) return;
      // enough copies for one group of slack on each side of the viewport
      while (r.track.scrollWidth < w * 2.5 + r.el.clientWidth && groups.length < 12) {
        const copy = groups[groups.length - 1].cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        r.track.appendChild(copy);
      }
      // first run: start one copy in, with the first card on the page gutter
      r.pos = r.w ? (r.pos / r.w) * w : w - gutter();
      r.w = w;
      apply(r);
    };

    rows.forEach((r) => {
      measure(r);
      r.el.addEventListener('scroll', () => {
        if (Math.abs(r.el.scrollLeft - r.set) > 1.5) { r.user = performance.now(); r.pos = r.el.scrollLeft; }
      }, { passive: true });
      r.el.addEventListener('touchstart', () => { r.held = true; }, { passive: true });
      const release = () => { r.held = false; r.user = performance.now(); };
      r.el.addEventListener('touchend', release, { passive: true });
      r.el.addEventListener('touchcancel', release, { passive: true });
    });

    let raf = 0;
    let last = 0;
    let onScreen = false;
    const frame = (t) => {
      raf = 0;
      if (!sec.isConnected) return;
      const dt = last ? Math.min(t - last, 50) / 1000 : 0;
      last = t;
      if (!(toggle && toggle.checked)) {
        rows.forEach((r) => {
          if (r.held || t - r.user < IDLE) return;
          r.pos += r.dir * r.speed * dt;
          apply(r);
        });
      }
      if (onScreen) raf = requestAnimationFrame(frame);
    };
    const start = () => { if (!raf && onScreen) { last = 0; raf = requestAnimationFrame(frame); } };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { onScreen = en.isIntersecting; start(); }, { rootMargin: '120px 0px' }).observe(sec);
    } else {
      onScreen = true;
      start();
    }

    let vw = window.innerWidth;
    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (window.innerWidth === vw) return; // ignore mobile URL-bar height changes
        vw = window.innerWidth;
        rows.forEach(measure);
      }, 150);
    }, { passive: true });
  };

  const boot = () => document.querySelectorAll('[data-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
